/**
 * @file VeriomeTextField.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @references:  
 * https://medium.com/google-design/the-evolution-of-material-designs-text-fields-603688b3fe03
 * https://stackoverflow.com/questions/48304062/material-ui-textfield-disable-browser-autocomplete
 * 
 * @author don michael
 * @since May 22, 2020 20:52
 */
import PropTypes from 'prop-types';

import TextField from '@mui/material/TextField';

function VeriomeTextField(props) {
    const {
        fieldErrors = {},
        fieldLabel,
        fieldName,
        currentValue,
        helpText = '',
        isFocus = false,
        isFullWidth = false,
        isMultiline = false,
        isRequired = false,
        isDisabled = false,
        sxStyle = null,
        handleBlur = () => { },
        handleChange,
        handleKeyDown,
    } = props;

    const multiline = isMultiline ? isMultiline : false;

    const inputProps = {
        autoComplete: 'off',
    };

    return (

        <TextField
            key={`${fieldName}-key`}
            id={`${fieldName}-field`}
            name={`${fieldName}-field`}
            label={fieldLabel ? fieldLabel : ''}
            value={currentValue ? currentValue : ''}
            sx={sxStyle}
            autoComplete="false"
            autoFocus={isFocus}
            disabled={isDisabled}
            onKeyDown={(event) => {
                if (handleKeyDown) {
                    handleKeyDown(event, fieldName);
                }
            }}
            onChange={(event) => {
                handleChange(event, fieldName);
            }}
            onBlur={() => {
                handleBlur(fieldName);
            }}
            fullWidth={isFullWidth}
            multiline={multiline}
            required={isRequired}
            size="small"
            margin="dense"
            variant="filled"
            error={fieldName ? Boolean(fieldErrors[fieldName]) : false}
            helperText={fieldErrors[fieldName] || helpText}
            InputProps={inputProps}
        />

    );
}

VeriomeTextField.propTypes = {
    fieldErrors: PropTypes.object,
    fieldLabel: PropTypes.string.isRequired,
    fieldName: PropTypes.string.isRequired,
    currentValue: PropTypes.string,
    helpText: PropTypes.string,
    isDisabled: PropTypes.bool,
    isFocus: PropTypes.bool,
    isFullWidth: PropTypes.bool,
    isMultiline: PropTypes.bool,
    isRequired: PropTypes.bool,
    sxStyle: PropTypes.object,
    handleBlur: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    handleKeyDown: PropTypes.func,
};

export default VeriomeTextField;